import { useNavigate } from 'react-router';
import { usePageTitle } from '../hooks/usePageTitle';

export function NotFoundPage() {
  const navigate = useNavigate();

  usePageTitle('404 - Page Not Found | Publishing Portal');

  return (
    <div className="min-h-screen bg-neutral-950 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-white mb-4">404</h1>
        <p className="text-xl text-gray-400 mb-8">Page not found</p>
        <button
          type="button"
          onClick={() => navigate('/')}
          className="px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
}
